import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {MenuItem} from '@components';

export const MENU = [
  {
    name: 'menusidebar.label.Dashboard',
    path: '/',
    icon: 'fas fa-tachometer-alt'
  },
  {
    name: 'menusidebar.label.SystemInfo',
    path: '/system-info',
    icon: 'fas fa-desktop'
  },
  {
    name: 'menusidebar.label.ONU.Parent',
    icon: 'fas fa-hdd',
    children: [
        {
            name: 'menusidebar.label.ONU.Status',
            path: '/onu/status'
        },
        {
            name: 'menusidebar.label.ONU.PONInfo',
            path: '/onu/info'
        }
    ]
  },
  {
    name: 'menusidebar.label.OLT.Parent',
    icon: 'fas fa-server',
    children: [
          {
            name: 'menusidebar.label.OLT.Status',
            path: '/olt/status'
          },
          {
            name: 'menusidebar.label.OLT.PONInfo',
            path: '/olt/info'
          },
          {
            name: 'menusidebar.label.OLT.Alarms',
            path: '/olt/alarms'
          },
      ]
    },    
    {
      name: 'menusidebar.label.ManagementCard.Parent',
      icon: 'fas fa-folder-minus',
      children: [
          {
            name: 'menusidebar.label.ManagementCard.LANAddress',
            path: '/management-card/lan-address'
          },
          {
            name: 'menusidebar.label.ManagementCard.SNMPAgent',
            path: '/management-card/snmp-agent'
          },
          {
            name: 'menusidebar.label.ManagementCard.NTPClient',
            path: '/management-card/ntp-client'
          },
          {
            name: 'menusidebar.label.ManagementCard.Password',
            path: '/management-card/password'
          },
          {
            name: 'menusidebar.label.ManagementCard.BackupRestore',
            path: '/management-card/backup-restore'
          },
          {
            name: 'menusidebar.label.ManagementCard.FactoryReset',
            path: '/management-card/factory-reset'
          },
          {
            name: 'menusidebar.label.ManagementCard.FirmwareUpgrade',
            path: '/management-card/firmware-upgrade'
          },
          {
            name: 'menusidebar.label.ManagementCard.Reboot',
            path: '/management-card/reboot'
          },
      ]
    },
    {
      name: 'menusidebar.label.Logout',
      path: '/logout',
      icon: 'fas fa-sign-out-alt'
    }
];

const MenuSidebar = () => {
    const user = useSelector((state) => state.auth.currentUser);

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <a href="https://www.tkth.com.br" className="brand-link" target="_new">
                <img src="/img/logo.png" alt="Think Technology" className="brand-image" />
            </a>
            <div className="sidebar">

                <nav className="mt-2" style={{overflowY: 'hidden'}}>
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {MENU.map((menuItem) => (
                            <MenuItem key={menuItem.name} menuItem={menuItem} menuItem={menuItem} menuItem={menuItem} menuItem={menuItem} menuItem={menuItem} />
                        ))}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;